module.exports = __webpack_public_path__ + "static/media/appointment.6d26602d.png";